(function Module() {
	'use strict';
	
	mySynch.controller('SectionPageV1_3Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'ApiFactory',
		'F360Service',
		'MySynchFactory',
		'CookieFactory',
		'$location',
		'AuditService',
		'$window',
		'F360Constant',
		'$timeout',
		'clientLoggerService',
		function SectionPageV1_3Controller($s,$rootScope, $interval,$q,api, f360Service, MSF,cookies, $location, auditService, $window, f360Constant, $timeout, log) {
			console.log("@@@@@@@@@ V1.3 Section Page @@@@@@@@");
			var self = this;
			$s.loadControl = function loadControl(template) {
				var questionTempalate = _.filter(MSF.lists.codeFile, {codeType: 'F360QUESTIONTMPL'});
				var detailValidation = JSON.parse(_.find(questionTempalate, {code: template}).detailsJson);
				var settingControl = detailValidation[0].settings[0];
				return  settingControl.width;
			};

			// for testing mobile 
			$s.debugConsoleText = "";
			
			$s.auditService = auditService;
			$s.currenUrl = '#' + $location.url();
			$s.arrCodeFile = _.cloneDeep(_.get(MSF,"lists.codeFile",[]));
			$s.val = '';
			var auditId = auditService.getAuditId($location.url());
			if ($s.sectionName === false) {
				$window.location.href = '#/f360';
			}
			$s.auditId = auditId;
			$s.isOnline = $rootScope.onLine;
			$s.auditApiVersion;

			$s.sectionName = auditService.getSection($location.url());
			$s.prePopulatedData = {};
			$s.sectionQuestions = [];
			$s.sectionSubheadings = [];
			$s.subheadingTitles = {};
			$s.auditAnswers = [];
			$.overViewList = [];
			$s.cowsInPenQuestions = {};
			$s.cowsInPenQuestionChanging = false;
			$s.notApplicableQuestions = {};
			$s.allowReviewComplete = false;

			// pixel distance to scroll to from the top when a question subheading is opened 
			$s.scrollTopValue = 200;

			
			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};
			$s.isUsingDairyComp = false;

			$s.excludedQuestionIds = [];
		   // flag for that is set true when and update answers call occurs successfuly without updating the server
		   $s.syncInProgress = false;
		   $s.initCheckSyncInProgress = false;
		   $s.isDirty = false;

		   $s.updateInProgress = false;
		   // an array of questions that are used to stop the saving spinner during after the final updateAnswer call of a multiple question answers are saved.
		   $s.saveQuestionAnswerQueue = [];
		 // flag used to mark if a final call to updateAnswer is required after several calls to updateAnswer were made  
		   $s.finalSaveRequired = false;

		   $s.checkSyncStatusTimer = undefined;
		   $s.updateFinishedTimeoutCancel = undefined;
		   $s.updateFinishedTimeoutInterval = 5000;

		   // TODO: put this in a proper place. Used to determine certain version of data. Ex: versions of data in CodeFile's DetailsJson field
            //const apiVersion = "v1.3";

		   $s.codeFile = [];


			$s.defaultAnswer = "";
			

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			//TODO remove later when a refactor of the body and lamness score occurs 
			var degregAuditAnswersWatch = undefined;
            // on load watch degreg to call hideAllQuestionsByReason when the questions are loaded
			$s.deregHideQuestionsTimer = undefined;
		
			function loadCurrentHerd(callback){
				   
				auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }
						$s.currentHerd =  herd[0];
						var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
								   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
					   if(_.isEqual(currentHMS,'DC305')){
						  $s.isUsingDairyComp = true;
					   }
						  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
							 MSF.loadPage('Login');
						  }
						  callback();
					         
				});

			 
		  }
		  $s.checkPermissions = function checkPermissions(callback){
				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: $s.auditId},'Name');
					 
					if(!_.isEqual(_.get(auditHerd,'PersonId'),_.get(cookies.user,'PersonId'))){
						MSF.loadPage('Fertility360report');
					}

					callback();

				});
			};

            // function to determine if the notes for a question should be shown
			$s.showNotes = function(question) {
				question.showNote = true;
				setTimeout(function(){
					$('#note' + question.QuestionId).focus();
				}, 100);
			};

			//function that removes an answer from the current audit's answer list for a given question id
			function removeAnswer(questionId){
				
				var remainingQuestions =  _.reject($s.auditAnswers, function(item){ return item.QuestionId == questionId;});
				
				 $s.auditAnswers = remainingQuestions;

			}
            //function that constructs the display value of a given text value  
            $s.getTextDisplayValue  = function getTextDisplayValue(text){

				// replace any measurement standard text 
				var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

				text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

				return text;

			};

            // function that takes in a collection of questions and adds a '%' to end of percentange questions's inputs
			function addPercentSignToPercentageQuestionInputs(questions){
				
				_.forEach(questions,function(question){
					
					// first we grab the question type to check if it is a percentage question 
					var questionType = _.get(question,'QuestionDetailsJson.fieldType','');

					//we only want to work with precentage questions
					if(_.isEqual(questionType,"Percentage")){
					   // next we need to grab the current answer value to check if it 
					    var answerValue =_.get(question,'Answer.Value','');
					   
					    //if the answer already has a '%' or the answer is blank we don't do anything
					    if(_.isEqual(_.last(answerValue),'%') || ( _.isEqual(answerValue,'') || _.isNull(answerValue) ) ){
							return;
						}else{
						
						 var tmp = [];
						 var precentDisplayValue = answerValue + '%';
						 tmp.push(precentDisplayValue);
						 var input =  $("input[id="+ question.QuestionId +"]");
						 if(input.length > 0){
						   input.val(tmp);
						 }else{
							 var auditQuestion = _.find($s.auditQuestions,{QuestionId: question.QuestionId});
							 if(!_.isUndefined(auditQuestion)){
								 _.set(auditQuestion,'Answer.Value', precentDisplayValue);
							 }
						 }
						}
					}

				});
				
			 }
			function makeSubheadingTitle(subHeadingKey, answerCount, totalCount) {
				var titleNA = false;
				if (typeof $s.notApplicableQuestions.SubHeading !== "undefined") {
					if ($s.notApplicableQuestions.SubHeading == subHeadingKey && $s.notApplicableQuestions.Answer.Value == f360Constant.answerTrue) {
						titleNA = true;
					}
				}
				if (titleNA) {
					//return subHeadingKey + ' ( N/A )';
					return subHeadingKey + ' ( ' + '0' + ' of ' + '0' + ' complete )';
				} else {
					return subHeadingKey + ' ( ' + answerCount + ' of ' + totalCount + ' complete )';
				}
			}

			// function that updates the questions's answer and auditAnswer properties
			function applyPrePopulatedData(questions){
				
				  var updatedSubHeadings = [];
                  _.forEach(questions,function(question){
					  //TODO: once we support more than dairyComp there will be more than one source of data  and this area will need to be refactored.
					   if(_.includes(_.get(question,'QuestionDetailsJson.dataSynced').toLowerCase(), 'yes')){

						   if(!_.includes(updatedSubHeadings,question.SubHeading)){
							   updatedSubHeadings.push(question.SubHeading);
						   }
						  
						   var dataField = _.get(question,'QuestionDetailsJson.herdMgmtSystem.dataField');

						   var populatedValue = undefined;
						   // if the dataField is not properly set for a synced question, then the answer value becomes a default value
						   if(_.isUndefined(dataField) || _.isNull(dataField) || _.isEqual(dataField,"")){


							  populatedValue = getDefaultPrePopulatedValue(question);
 
						   }else{
							   
							   var populatedDataItem = _.find(_.get($s.prePopulatedData,'PrePopFields'),{PrePopulateCode:dataField});
							    // if the prepopulated data does not exist for the matching question's data field, the answer value becomes a default value
							   if(_.isUndefined(populatedDataItem)){
								  populatedValue = getDefaultPrePopulatedValue(question); 
							   }else{

								  //if both prepopulated values are null then the answer value becomes a default value
								  if(_.isNull(populatedDataItem.ResultNumValue) && _.isNull(populatedDataItem.ResultStrValue)){
									populatedValue = getDefaultPrePopulatedValue(question); 
								  }else{
									  if(!_.isNull(populatedDataItem.ResultNumValue)){
										populatedValue = populatedDataItem.ResultNumValue;
									  }else{
                                        if(_.isEqual(_.get(question,'CodeType'),"MONTH")){
											var resultStrValue = [{Month:"none"}];
											if(_.isArray(populatedDataItem.ResultStrValue)){
											   resultStrValue = populatedDataItem.ResultStrValue;
											}else{
												resultStrValue = JSON.parse(populatedDataItem.ResultStrValue);
											}
												
												var answers = _.pluck(resultStrValue,'Month');
												var answerList = arrayToStringListOfValues(answers);
												populatedValue = answerList;
												

										}else{
											populatedValue = populatedDataItem.ResultStrValue;
										}

										
									  }
								  }
								  var prePopAutoNotes = undefined;
								  if(!_.isNull(populatedDataItem.ResultNoteValue)){
									prePopAutoNotes = populatedDataItem.ResultNoteValue; 
								  }
							}

						   }

						   if (isPercentQuestionTemplate(question)) {

							populatedValue = Math.round(populatedValue);
						
							var precentCalculatedValue = populatedValue + '%';
							//adjustedValue = precentCalculatedValue
							_.set(question,"Answer.Value",precentCalculatedValue);
									
						}

						   var populatedAnswer = angular.copy($s.defaultAnswer);
						   _.set(populatedAnswer,'AnswerDetailsJson.Answered',					true);
						   _.set(populatedAnswer,'AnswerDetailsJson.Value',						populatedValue);
						   _.set(populatedAnswer,'AnswerDetailsJson.MetGuideline',				_.get(question,'Answer.MetGuideline'						));
						   _.set(populatedAnswer,'AnswerDetailsJson.NoGuideInvolved',			_.get(question,'Answer.NoGuideInvolved',			null	));
						   _.set(populatedAnswer,'AnswerDetailsJson.Notes',						_.get(question,'Answer.Notes',						prePopAutoNotes));
						   _.set(populatedAnswer,'AnswerDetailsJson.ActionItem',				_.get(question,'Answer.ActionItem',					false	));
						   _.set(populatedAnswer,'AnswerDetailsJson.IncludeIndustryRecommends',	_.get(question,'Answer.IncludeIndustryRecommends',	false	));
						   _.set(populatedAnswer,'AnswerDetailsJson.FormattedRecommends',		_.get(question,'Answer.FormattedRecommends'					));
						   _.set(populatedAnswer,'AnswerDetailsJson.MgmtAccepted',				_.get(question,'Answer.MgmtAccepted',				false	));
						   _.set(populatedAnswer,'AnswerDetailsJson.TargetDate',				_.get(question,'Answer.TargetDate',					null	));
						   _.set(populatedAnswer,'AnswerDetailsJson.Status',					_.get(question,'Answer.Status',						null	));


						   // need to check met guidelines somewhere here
						   var metGuidelines = true;
							var detailValidation = _.get(question,'QuestionDetailsJson.industryGuideline');
							if (detailValidation && detailValidation.compare) {
								metGuidelines = $s.validateCompare(detailValidation.compare, populatedValue, question);
							}

							
                            _.set(populatedAnswer,'AnswerDetailsJson.MetGuideline',metGuidelines);
						  
						   _.set(question,'Answer',angular.copy(populatedAnswer.AnswerDetailsJson));

						   var auditAnswer = _.find($s.auditAnswers,{QuestionId: question.QuestionId});
							
						    if(_.isUndefined(auditAnswer)){
                                 
								  _.set(populatedAnswer,'QuestionId',question.QuestionId);								 
								 
								 $s.auditAnswers.push(populatedAnswer);
							}else{
								_.set(auditAnswer,'AnswerDetailsJson',angular.copy(populatedAnswer.AnswerDetailsJson));	
							}
							 
							

						
					   }
					   // if the question has a calcTag , then we need to update the a question's value that this question is used in a calculaton for. 
						var calcTags = _.get(question,'QuestionDetailsJson.calcTag',null);
						if(!_.isNull(calcTags)){
							questionWithCalculationTagChanged(question,calcTags);
						} 

				  });

				  // once all of the prepopulated questions that have answers are updated we need to save those answers and update each subheading's counts that had a question prepopulated

				  if(!_.isEmpty($s.auditAnswers)){

					  var auditAnswerJson = JSON.stringify($s.auditAnswers);
					  
					  updateAnswer(auditId,auditAnswerJson,true);

					  _.forEach(updatedSubHeadings,function(subHeading){
                        countAnsweredQuestions(subHeading);
					  });
				  }else{
					  // no answers were actually saved if $s.auditAnwers is empty , so update in progress is over.
					$s.updateInProgress = false;
				  }
			}
			// function that takes in a question and returns a default PrePopulated value based on a question's template.
			function getDefaultPrePopulatedValue(question){

				var value = null;

				var template = _.get(question,'QuestionTemplate');
				var codeType = _.get(question,'CodeType');
				
				switch (template) {
					case "INT3":
					case "INT4":
					case "DEC4,2":
					case "DEC6,2":
					case "DEC3,1":
					case "%3,0":
					case "%5,1":	
						value = 0;
				        break;
					case "SINGL":
					case "MULTI":
						if(_.isEqual(codeType,'MONTH')){
                            value = "('none')";
						}else{
							value = "";
						}
						break;
					case "YN":
					case "TF":
						value = "";
						break;
				}

				return value;
			}

			// questions wil have a HiddenReasons string array at the top level that will be used along with jQuery 
			// to hide them given a reason. 
			
			//parameter "unhide" is a boolean flag to determine if the function willshow previously hidden questions
            $s.hideShowQuestionsByReason = function hideShowQuestionsByReason(initiatorQuestion,reason){

				var initQuestionId = _.get(initiatorQuestion,'QuestionId');
				var initQuestionInput =  "" ;
				var initQuestionInputValue = "";
				
				 var questionTemplate = _.get(initiatorQuestion,'QuestionTemplate',"");
				 // Since we don't have a need for the text , multi select and single select (other than TF) questions to hide other questions,
				 // this untested start on this functionallity will be commented out for now. 
				 
				 // text inputs
				//  if($s.checkTypeControlInput(questionTemplate)){

				// 	 iniQuestionInput = $("#question"+iniQuestionId).find("input");
					 
		        //      iniQuestionInputValue = iniQuestionInput.val();	  
									 
					 
				//  }
				 if($s.checkTypeControlSingl(questionTemplate)){
					
					// TF questions
					if(_.isEqual(questionTemplate,"TF")){
						initQuestionInput = $("#question"+initQuestionId).find("input");

						initQuestionInputValue = initQuestionInput.prop("checked");
					  }
					// multi select questions
					//else{
					// 	iniQuestionInput = $("#question"+iniQuestionId).find(":checked");
					// 	iniQuestionInputValue = iniQuestionInput.val();	
					 
					// }
				 }

				  
			   
				var questionsToHide = _.filter($s.auditQuestions,function(question){ return _.includes(question.HiddenReasons,reason); });
				
				_.forEach(questionsToHide, function(question){
					   var questionId = _.get(question,'QuestionId',"");   
					   var questionJqo = $("#question"+questionId);
					   
					   var hideQuestionWhenValue = _.get(initiatorQuestion,'HideQuestionWhenValue');
					   
					   if(questionJqo.length > 0 && !_.isUndefined(hideQuestionWhenValue)){

                           if(_.isEqual(initQuestionInputValue,hideQuestionWhenValue)){
							 questionJqo.addClass("dis-none");
						   }else{
							 questionJqo.removeClass("dis-none"); 
						   }

					   }
					
      
				});


			};
            $s.hideAllQuestionsByReason = function hideAllQuestionsByReason(questions){
				_.forEach(questions,function(question){
					
					var hideQuestionReason = _.get(question,'HideQuestionReason');

					if(!_.isUndefined(hideQuestionReason)){
						$s.hideShowQuestionsByReason(question,hideQuestionReason);
					}
				});
			};
        $s.loadReportData = function loadReportData(){
			auditService.getIndexedDbPrePopulatedData(auditId, function getIndexedDbPrePopulatedData(err, data) {
				if(err){
					log.error('error getting F360 PrePopulated Data: ' + err);
					MSF.confirmation.danger(err,false);
				}	
				
				if (data && data.length > 0) {
                     $s.prePopulatedData = data[0];
				}
				auditService.getIndexedDBOverViewList(auditId, function getIndexedDBOverViewList(err, overviewListData) {
					if (err) {
						log.error('error getting overView list: ' + err);
						MSF.confirmation.danger(err,false);
					}

				
					if (overviewListData && overviewListData.length) {
						
						$s.overViewList = overviewListData;
					}
				auditService.getIndexedDBQuestionList(auditId, function getIndexedDBQuestionList(err, data) {
					if (err) {
						log.error('error getting F360 Over View List: ' + err);
						MSF.confirmation.danger(err,false);
					}
					
					if (data && data.length) {
						var arrQuestion = [];
						var parseDataQuestion = JSON.parse(data);
						var questionDetailsJson = parseDataQuestion.QuestionsJson;
					
						for (let i = 0; i < questionDetailsJson.length; i++) {
							arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
						}
						// we need to order the questions here in the ux because the questions come from a JSON field
						// intead their own records in a table.
						$s.auditQuestions = _.sortByOrder(arrQuestion,['SortOrder'],['asc']);
						var sectionQuestions = _.filter($s.auditQuestions, {Section: $s.sectionName});
						auditService.getIndexedDBAnswerList(auditId, function getIndexedDBAnswerList(err, data) {
							if (err) {
								console.log('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
							} 
							if (data && data.length) {
								try{
								 $s.auditAnswers = JSON.parse(data);
								}catch(e){
								  log.error("failed to parse answer list json : "+_.get(e,'message'," "));
								}
							 
							 
							 } else {
								$s.auditAnswers = [];
							 }
							for (let index = 0; index < sectionQuestions.length; index++) {
								var answerData = $s.loadAnswerData(sectionQuestions[index].QuestionId);
								sectionQuestions[index].Answer.Answered = answerData.Answered;
								sectionQuestions[index].Answer.Value = answerData.Value;
								sectionQuestions[index].Answer.oldValue = answerData.Value;
								sectionQuestions[index].Answer.MetGuideline = answerData.MetGuideline;
								sectionQuestions[index].Answer.NoGuideInvolved = answerData.NoGuideInvolved;
								sectionQuestions[index].Answer.Notes = answerData.Notes;
								
								var referentKey = sectionQuestions[index].Section + '_' + sectionQuestions[index].SubHeading;
								if (auditService.checkQuestionNumberCowsInPen(sectionQuestions[index])) {
									$s.cowsInPenQuestions[referentKey] = sectionQuestions[index];
								}
								if (auditService.checkNotApplicable(sectionQuestions[index])) {
									$s.notApplicableQuestions = sectionQuestions[index];
								}
								if (auditService.checkAverageQuesitonBCS(sectionQuestions[index])
								|| auditService.checkAverageQuesitonLS(sectionQuestions[index])) {
									sectionQuestions[index].RelyOnQuestion = $s.cowsInPenQuestions[referentKey];
								} else {
									sectionQuestions[index].RelyOnQuestion = null;
								}
							}
	                      if($s.isUsingDairyComp){
							// before we assign the questions to the model, we need to update both questions and answers with any prepopulated data if the farm is using dairy comp
								var sectionContainsPrePopulatedQuestions = false;
								_.forEach(sectionQuestions,function(question){

									if(_.includes(_.get(question,'QuestionDetailsJson.dataSynced').toLowerCase(), 'yes')){
										sectionContainsPrePopulatedQuestions = true;
									}

								});
								
								if(sectionContainsPrePopulatedQuestions){
								applyPrePopulatedData(sectionQuestions);
								} 
							}

							$s.sectionQuestions = sectionQuestions;
							var sectionSubheadings = _.groupBy($s.sectionQuestions, 'SubHeading');
							$s.sectionSubheadings = Object.keys(sectionSubheadings);
							var hideSubHeading = $s.sectionSubheadings.length <= 1;
							var arrSubHeadings = [];
							var elementSubHeading = '';

							var sectionScroll = localStorage.getItem(f360Constant.keySectionScroll);
							var sectionScrollData = JSON.parse(sectionScroll);
							for (let i = 0; i < $s.sectionSubheadings.length; i++) {
								var subHeadingKey = $s.sectionSubheadings[i];
								var show = true;
								if ($s.sectionSubheadings[i] === '---') {
									show = false;
								}

								if ((sectionScrollData && sectionScrollData.subHeading == subHeadingKey) || (_.isEqual(subHeadingKey,"---")))
								{
									hideSubHeading = true;
								}else{
									hideSubHeading = false;
								}
								var infoText = '';
								switch (subHeadingKey.trim()) {
									case "Dry Cows Far-Off":
										infoText = 'Cows that are 60-21 days from calving.';
										break;
									case "Dry Cows Close-Up":
										infoText = 'Cows that are 21 days or less from calving.';
										break;
									case "Fresh Cows":
										infoText = 'Cows that have calved up to 21 days ago.';
										break;
									case "Milking Cows":
										infoText = 'Cows that have calved over 21 days ago.';
										break;
								}
								elementSubHeading = {
									"subHeading": subHeadingKey,
									"active": hideSubHeading ? true : false,
									"show": show,
									"answerCount": 0,
									"title": '',
									"infoText": infoText
								};
								$s.subheadingTitles[i] = makeSubheadingTitle(subHeadingKey, 0, _.filter($s.sectionQuestions, {SubHeading: subHeadingKey}).length);
								arrSubHeadings.push(elementSubHeading);
							}
							$s.sectionSubheadings = arrSubHeadings;
							
							for (let index = 0; index < $s.sectionSubheadings.length; index++) {
								countAnsweredQuestions($s.sectionSubheadings[index].subHeading);
							}

							if (sectionScrollData) {
								setTimeout(function() {
									var questionScoring = document.getElementById(sectionScrollData.questionId);
									var locationScroll = $(questionScoring).offset().top - f360Constant.scrollNumberSection;
									window.scrollTo(0, locationScroll);
								}, 200);
								localStorage.removeItem(f360Constant.keySectionScroll);
							}

							if (!$s.$$phase) {
								$s.$digest();
							}
							if (!$s.isOnline) {
								$s.$apply();
							}

							addPercentSignToPercentageQuestionInputs($s.sectionQuestions);
							
							// first try to see if the questions are loaded in into the dom by testing the first question
							
							var firstQuestion  = $("#question1");
							
							// if the question exists then we can hide questions that should be hidden
							if(firstQuestion.length > 0){
								$s.hideAllQuestionsByReason($s.sectionQuestions);
							}else{
								$s.deregHideQuestionsTimer = $interval(function(){
									var firstQuestion  = $("#question1");
									
									var questionsExist = firstQuestion.length > 0;

									if(questionsExist){
										log.info("questions now exist hiding questions and canceling timer");
										$s.hideAllQuestionsByReason($s.sectionQuestions);
										$interval.cancel($s.deregHideQuestionsTimer);
									}
									
								},100);
							}
							
                            
                            $s.deregScrollTop = undefined;
							
                           var accordionDiv = $(".subheading-area");
                           
                           if(accordionDiv.length > 0){
								$( '.subheading-area' ).click( function(e) {
									var pane = $(this);
									setTimeout(function(){
									
											  $("html,body").animate({
											  	scrollTop: 0
											  }, "fast");
											
									}, 300 );
								});
							}else{
							  $s.scrollTopTimer = $interval(function(){
									   
									var accordionDiv = $(".subheading-area");
									
									var accordionExists = accordionDiv.length > 0;
                                  
									if(accordionExists){
										log.info("accordion exits set on even hook and cancel timer");
										$( '.subheading-area' ).click( function(e ) {
											var pane = $(this);
											setTimeout(function(){
										 
												$("html,body").animate({
													scrollTop: 0
												}, "fast");
											
											}, 300 );
										});
										$interval.cancel($s.scrollTopTimer);
									}

							   },100);
							}
						     


						});
					} else {
						$window.location.href = '#/f360';
					}
				});
			  });
			});
		};

			$s.loadAnswerData = function(quesionId) {
				for (let i = 0; i < $s.auditAnswers.length; i++) {
					if (quesionId == $s.auditAnswers[i].QuestionId) {
						return $s.auditAnswers[i].AnswerDetailsJson;
					}
				}
				return '';
			};

			if (!$s.isOnline) {
			//	$s.$apply();
			}


			$s.activeSubHeading = function activeSubHeading(subHeading) {
				for (const sub of $s.sectionSubheadings) {
					if (subHeading == sub.subHeading) {
						if (sub.active) {
							sub.active = false;
						} else {
							sub.active = true;
							
						}
					} else {
						sub.active = false;
					}
				}
			};
			$s.checkTypeControlInput = function checkTypeControlInput(template) {
				switch (template) {
					case "INT3":
					case "NATNUM3":
					case "INT4":
					case "NATNUM4":
					case "DEC4,2":
					case "DEC6,2":
					case "DEC3,1":
					case "%3,0":
					case "%5,1":	
						return true;
				
					case "SINGL":
				    case "MULTI":
					case "YN":
					case "TF":
						return false;
				}
			};
			$s.checkTypeControlSingl = function checkTypeControlSingl(template) {
				switch (template) {
					case "INT3":
					case "INT4":
					case "DEC4,2":
					case "DEC6,2":
					case "DEC3,1":
					case "%3,0":
					case "%5,1":	
						return false;
				
					case "SINGL":
					case "MULTI":
					case "YN":
					case "TF":
						return true;
				}
			};

			function isPercentQuestionTemplate(questionDetails) {
				if (questionDetails.QuestionTemplate == "%3,0" ||questionDetails.QuestionTemplate == "%5,1" ) {
					return true;
				}
				return false;
			}
			function restoreAnswer(question,oldValue){
                _.set(question,'Answer.Value',oldValue);
			}
			//function that resets a questions Answer properties 
            function resetQuestionAnswer(question){
				_.set(question,'Answer.Value','');
				_.set(question,'Answer.oldValue','');
				_.set(question,'Answer.Answered',false);
				_.set(question,'Answer.MetGuideline',true);			
			}
			//function that clears the answer of questions when the specific question they are dependent on changes
			function clearDependentQuestionAndAnswersData(parentQuestionId,oldValue){
                _.forEach($s.auditQuestions,function(question){
					var relyOnQuestion = _.get(question,'RelyOnQuestion','');
					if(relyOnQuestion != '' && !_.isNull(relyOnQuestion)){
						
						if(_.isEqual(relyOnQuestion.QuestionId,parentQuestionId) && !_.isEqual(_.get(relyOnQuestion,'Answer.Value',undefined),oldValue)){
							 
							removeAnswer(question.QuestionId);
							resetQuestionAnswer(question);
						 
							if(auditService.checkAverageQuesitonBCS(question)){
								// local storage of body scores
								var bscValuesKey = $s.auditId + '_' + auditService.getSubHeading(question.SubHeading) + question.QuestionId + '_bcs_';
								localStorage.removeItem(bscValuesKey);
							}	
							if(auditService.checkAverageQuesitonLS(question)){
								// local storage of lameness scores
								var bscValuesKey = $s.auditId + '_' + auditService.getSubHeading(question.SubHeading) + question.QuestionId + '_ls_';
								localStorage.removeItem(bscValuesKey);
							}	
							
						

						}
					}
				});
			}

			// function that takes the changed question and an array of calcTags and updates question's answers that are based on calculations 
			function questionWithCalculationTagChanged(changedQuestion,calcTags){
				// we need to go each calcTag the question's value that changed
			 _.forEach(calcTags, function(calcTag){
                  // and go through each of the questions to see if the changed question needs to update other calculated questions
				_.forEach($s.auditQuestions,function(question){ 
				
					// only questions that have their value based on calculations will have a calculations property
					if(!_.isUndefined(_.get(question,'QuestionDetailsJson.calculations'))){
					   
					    _.forEach(_.get(question,'QuestionDetailsJson.calculations.calculationVars',[]),function(calcVar){
							// if the question calculated question is based off of the current calcTag, then we move on to trying to update the answer
							// using _.find here to grab the calcVarObj without having to know the name of the calcVar property name
							var calcVarObj = _.find(calcVar,'valueTag');
							if(_.includes(calcVarObj.valueTag,calcTag) && _.isEqual(calcVarObj.section,changedQuestion.Section) && _.isEqual(calcVarObj.subHeading,changedQuestion.SubHeading)){
								   
								var breakpoint = "";
								updateCalculatedQuestion(question); 
								countAnsweredQuestions(question.SubHeading);                             

							}
							
						});

					}


				});

			 });	
				

			}
			//function that updates a question's answer that is based on a calculation
			function updateCalculatedQuestion(question){
		
				var calculatedValue = getCalculatedValue(question);
				var adjustedValue = "";
				if(_.isEqual(calculatedValue,'')){                  
                	resetQuestionAnswer(question);    
				}else{

					

					var metGuidelines = true;
					var detailValidation = _.get(question,'QuestionDetailsJson.industryGuideline');
					 if (detailValidation && detailValidation.compare) {
						metGuidelines = $s.validateCompare(detailValidation.compare, calculatedValue, question);
					}

					_.set(question,"Answer.MetGuideline",metGuidelines);
					_.set(question,"Answer.Answered",true);	
					
					//TODO: Clean up this section later to reduce the number of if/else
					if (isPercentQuestionTemplate(question)) {

						adjustedValue = Math.round(calculatedValue);
					
						var precentCalculatedValue = adjustedValue + '%';
						//adjustedValue = precentCalculatedValue
						_.set(question,"Answer.Value",precentCalculatedValue);
								
					}else{
					  if(_.isEqual(_.get(question,'QuestionDetailsJson.calculations.calculationTemplate',""),"BELOWGUIDE")){
						adjustedValue = calculatedValue;
						
					  }else{
						 if(_.isEqual(_.get(question,'QuestionDetailsJson.calculations.calculationTemplate',""),"ABS_DIFF")){
                            adjustedValue = calculatedValue.toFixed(1);
						 }else{
							 //TODO: Update the question json to account for questions that are a "count" whole integer 
							if(_.isEqual(_.get(question,'QuestionId'),83)){
								adjustedValue = calculatedValue.toFixed();	 
							}else{
								adjustedValue = calculatedValue.toFixed(2);	 
							}
								
						 } 
						
					 
					  }	
					  _.set(question,"Answer.Value",Number(adjustedValue));	
					}
					
				

					
				}
				
                 if(!_.isEqual(adjustedValue,"")){
					adjustedValue = Number(adjustedValue); 
				 }

				autoSave(question,adjustedValue,_.get(question,'Answer.Notes',''));

				
				

			}
			//function that returns the cacluated value to a question's answer that is based on a calculation
			function getCalculatedValue(calcQuestion){
				var calculatedValue = '';
				var calculationTemplate = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationTemplate');
		
				switch(calculationTemplate){

					case "RATIO":
						// valueTag is an array, but since we are only using one tag per valueTag we just take the first array position.
						var numeratorVar = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationVars[0].numerator',undefined);
						var denominatorVar = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationVars[1].denominator',undefined);

						var numeratorQuestions = _.filter($s.auditQuestions,function(question){ return _.isEqual(_.get(question,'QuestionDetailsJson.calcTag[0]',''),numeratorVar.valueTag[0]) && _.isEqual(question.Section,numeratorVar.section,'') && _.isEqual(question.SubHeading,numeratorVar.subHeading);});
						var denominatorQuestions = _.filter($s.auditQuestions,function(question){ return _.isEqual(_.get(question,'QuestionDetailsJson.calcTag[0]',''),denominatorVar.valueTag[0]) && _.isEqual(question.Section,denominatorVar.section) && _.isEqual(question.SubHeading,denominatorVar.subHeading);});
				   
					// for both compare values, we need to check if all of the calc question values are unanwered or blank 
					// if so we need to set that compare value to and empty string
						var numeratorSum = _.sum(numeratorQuestions,function(question){return question.Answer.Value;});
						
						var numQuestionAnswers = _.compact(_.pluck(numeratorQuestions,'Answer.Value'));
						if(numQuestionAnswers.length == 0){
							numeratorSum = "";
						}

						var denominatorSum = _.sum(denominatorQuestions,function(question){return question.Answer.Value;});
						
						var denomQuestionAnswers = _.compact(_.pluck(denominatorQuestions,'Answer.Value'));
						if(denomQuestionAnswers.length == 0){
							denominatorSum = "";
						}

						if(_.isEqual(numeratorSum,"") ||  _.isEqual(denominatorSum,"")){
							calculatedValue = "";
							break;
						}

						var ratioCodeFileObj = _.find($s.codeFile,{code: "RATIO"});
						var detailsJson = "";
						if(_.has(ratioCodeFileObj,'detailsJson') && !_.isNull(ratioCodeFileObj.detailsJson)){
							
							try{ 
								var detailsJsonVersions = JSON.parse(ratioCodeFileObj.detailsJson);
								if(detailsJsonVersions.length > 0){
									detailsJson = detailsJsonVersions[0];
								}						
							}catch(e) {log.info("Failed to parse detailsJson of the RATIO detailsJson")};
						
						 }
                     
						if(_.isEqual(numeratorSum,0)){
						   calculatedValue = _.get(detailsJson,'numerator.valueIf0',0);
						   break;
						}
						if(_.isEqual(denominatorSum,0)){
							calculatedValue = _.get(detailsJson,'denominator.valueIf0',0);
							break;
						 }
							
							

								if(isPercentQuestionTemplate(calcQuestion)){
										
									calculatedValue = (numeratorSum*100)/denominatorSum;
								
								}else{
									calculatedValue = numeratorSum/denominatorSum;
								}
					
						

					break;
					case "BELOWGUIDE":
				     var calcVar = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationVars[0].count',undefined);	
					 var failedGuidelineQuestions = _.filter($s.auditQuestions,function(question){ 
						 return _.isEqual(_.get(question,'QuestionDetailsJson.calcTag[0]',''),calcVar.valueTag[0])
						        && _.isEqual(_.get(question,'Answer.MetGuideline',''),false)   
								&& _.isEqual(question.Section,calcVar.section,'') 
								&& _.isEqual(question.SubHeading,calcVar.subHeading);
					 });	  
					 
					 calculatedValue = failedGuidelineQuestions.length;

					break; 
					case "ABS_DIFF":
					   // valueTag is an array, but since we are only using one tag per valueTag we just take the first array position.
						var value1Var = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationVars[0].value1',undefined);
						var value2Var = _.get(calcQuestion,'QuestionDetailsJson.calculations.calculationVars[1].value2',undefined);

						var value1Questions = _.filter($s.auditQuestions,function(question){ return _.isEqual(_.get(question,'QuestionDetailsJson.calcTag[0]',''),value1Var.valueTag[0]) && _.isEqual(question.Section,value1Var.section,'') && _.isEqual(question.SubHeading,value1Var.subHeading);});
						var value2Questions = _.filter($s.auditQuestions,function(question){ return _.isEqual(_.get(question,'QuestionDetailsJson.calcTag[0]',''),value2Var.valueTag[0]) && _.isEqual(question.Section,value2Var.section) && _.isEqual(question.SubHeading,value2Var.subHeading);});

						var value1Sum = _.sum(value1Questions,function(question){return question.Answer.Value;});
						var value2Sum = _.sum(value2Questions,function(question){return question.Answer.Value;});


						if(_.isEqual(value1Sum,0) || _.isEqual(value2Sum,0)){
							break;
						}

						calculatedValue = Number(Math.abs(value1Sum - value2Sum).toFixed(1));
						
                        
					break;
				}

				return calculatedValue;
			}
			$s.cancelChange = function cancelChange() {
				var changeModal = document.getElementById("changeModal");
				changeModal.style.display = "none";
				var referentKey = $(changeModal).attr('data-ref');
				$(changeModal).attr('data-ref', '');
				$s.cowsInPenQuestions[referentKey].Answer.Value = $s.cowsInPenQuestions[referentKey].Answer.oldValue;
			};
			$s.applyChange = function applyChange() {
				var changeModal = document.getElementById("changeModal");
				changeModal.style.display = "none";
				var referentKey = $(changeModal).attr('data-ref');
				$(changeModal).attr('data-ref', '');
				var questionDetails = $s.cowsInPenQuestions[referentKey];

				var note = questionDetails.Answer.Notes;
				if (typeof note === 'undefined') {
					note = '';
				}
				

				clearDependentQuestionAndAnswersData(questionDetails.QuestionId,questionDetails.Answer.oldValue);
				autoSave(questionDetails, questionDetails.Answer.Value, note);
			};
			

			function countAnsweredQuestions(subHeading) {
				var answerCount = 0;
				for (let i = 0; i < $s.sectionQuestions.length; i++) {
					var question = $s.sectionQuestions[i];
					var answerValue = _.get(question,'Answer.Value','');
					if(isPercentQuestionTemplate(question)){
						answerValue =  String(answerValue).replace('%','');
					}
					if (question.SubHeading == subHeading) {
						for (let j = 0; j < $s.auditAnswers.length; j++) {
							if (question.QuestionId == $s.auditAnswers[j].QuestionId
								&& answerValue == $s.auditAnswers[j].AnswerDetailsJson.Value
								&& (!_.isEqual($s.auditAnswers[j].AnswerDetailsJson.Value,''))
								&& !_.isEqual(question.QuestionId,$s.notApplicableQuestions.QuestionId)
								&& !_.includes($s.excludedQuestionIds,question.QuestionId)) {
								answerCount++; 
							}
						}
					} 
				}
				var totalAnsweredCount = 0;
				var totalQuestions = _.reject($s.sectionQuestions,function(question){ return _.isEqual(question.QuestionId,$s.notApplicableQuestions.QuestionId) || _.includes($s.excludedQuestionIds,question.QuestionId); }).length;
				for (let index = 0; index < $s.sectionSubheadings.length; index++) {
					
					 var totalQuestionsOfSubHeading = _.filter($s.sectionQuestions, function(question){return _.isEqual($s.sectionSubheadings[index].subHeading,question.SubHeading) && !_.isEqual(question.QuestionId,$s.notApplicableQuestions.QuestionId) && !_.includes($s.excludedQuestionIds,question.QuestionId);}).length;
			
					if ($s.sectionSubheadings[index].subHeading == subHeading) {
						$s.sectionSubheadings[index].answerCount = answerCount;
						$s.subheadingTitles[index] = makeSubheadingTitle(subHeading, answerCount, totalQuestionsOfSubHeading);
					}
					var ignoreSumAnswer = false;
					if (typeof $s.notApplicableQuestions.SubHeading !== "undefined") {
						if ($s.notApplicableQuestions.SubHeading == $s.sectionSubheadings[index].subHeading && $s.notApplicableQuestions.Answer.Value == f360Constant.answerTrue) {
							ignoreSumAnswer = true;
						}
					}
					if (ignoreSumAnswer) {
						totalQuestions = totalQuestions - totalQuestionsOfSubHeading;
					} else {
						totalAnsweredCount += $s.sectionSubheadings[index].answerCount;
					}
				}
				$s.allowReviewComplete = totalAnsweredCount === totalQuestions;
			}
			$s.checkGuidelines = function(question){
				var metGuideline = _.get(question,'Answer.MetGuideline',true);
				
				return metGuideline;
			};
			// function that checks to see if the an answer choice for a single or multi selection question should be checked
			$s.checkSelectCheckedStatus = function(question,answerCode){
				var isChecked = false;
				var answerValue = _.get(question,'Answer.Value','');
				var questionTemplate = _.get(question,'QuestionTemplate');
				var codeType =  _.get(question,'CodeType');
				 switch(questionTemplate){
						case "SINGL":
							if(_.isEqual(answerCode,answerValue)){
								isChecked =  true;
							}
							break;
						case "MULTI":
							
								var valueArray = stringListOfValuesToArray(answerValue);
								if(_.includes(valueArray,answerCode)){
									isChecked =  true;
								}
							
							break;
						case "YN":
                           if(_.isEqual(answerCode,answerValue)){
							   isChecked = true;
						   }
						   break;
				 }
				

				return isChecked;
				
			};
            $s.initializeBooleanValue = function(question){
				var value = _.get(question,'Answer.Value','F');
				var answered = _.get(question,'Answer.Answered',true);

				if(_.isNull(answered)){
					answered = true;
				}

				_.set(question,'Answer.Value',value);
				_.set(question,'Answer.Answered',answered);
								
			};
			$s.scrollToTopQuestion = function(){
                var activeSubHeading = _.find($s.sectionSubheadings,{active:true});
				var subheadingQuestions = _.filter($s.sectionQuestions,{SubHeading: activeSubHeading.subHeading});
				var topQuestion = subheadingQuestions[0];
              
				var topErrorElem =  $("#question"+topQuestion.QuestionId);
				   
			
				var container = $("#test1");
		
				if(!_.isUndefined(topErrorElem)){					
					$("body").scrollTop(topErrorElem.offset().top - container.offset().top + container.scrollTop()+ 200);							
				}
			
			};
			$s.scrollToTopOfSection = function scrollToTopOfSection(){
				$("body").scrollTop($s.scrollTopValue);
			};

			
		  
			

           // function that updates the notes of a question 
			$s.updateAnswerNote = function(question){
				
				var note = _.get(question,'Answer.Notes','');

				_.set(question,'showNote', note.length > 0);

				var auditAnswer = _.find($s.auditAnswers,{QuestionId: question.QuestionId});
				if(_.isUndefined(auditAnswer)){
                  
				   var newAnswer = angular.copy($s.defaultAnswer);
				   _.set(newAnswer,'QuestionId',question.QuestionId);  
				   _.set(newAnswer,'AnswerDetailsJson.Notes',note);
				   
				   $s.auditAnswers.push(newAnswer);
				}else{
					_.set(auditAnswer,'AnswerDetailsJson.Notes',note);
				}
				startAnswerSaveSpinner(question);
				var answerJson = JSON.stringify($s.auditAnswers);
				if(!_.isUndefined(question)){	
					question.Answer.oldValue = question.Answer.Value;
				}
				updateAnswer(auditId,answerJson,false,question);

				stopAnswerSaveSpinner(question);
			};
			$s.processAnswer = function(questionDetails) {
				log.info("begining processing answer");
		
				var questionBySubheading = _.filter($s.sectionQuestions, {SubHeading: questionDetails.SubHeading});
				var averageQuesitonBcs = _.filter(questionBySubheading, {Question: `${f360Constant.questionAverageBCS} `});
				var averageQuesitonLs = _.filter(questionBySubheading, {Question: f360Constant.questionAverageLS});

				var averageQuesitonBcsValue = '';
				if (averageQuesitonBcs && averageQuesitonBcs.length > 0) {
					averageQuesitonBcsValue = averageQuesitonBcs[0].Answer.Value ? averageQuesitonBcs[0].Answer.Value : '';
				}

				var averageQuesitonLsValue = '';
				if (averageQuesitonLs && averageQuesitonLs.length > 0 ) {
					averageQuesitonLsValue = averageQuesitonLs[0].Answer.Value ? averageQuesitonLs[0].Answer.Value : '';
				}
				
				var note = questionDetails.Answer.Notes;
				if (typeof note === 'undefined') {
					note = '';
				}
				questionDetails.showNote = note.length > 0;

				var detailQuetionControl = questionDetails.QuestionDetailsJson;
				if (typeof questionDetails.Answer.Value === 'undefined') {
					questionDetails.Answer.Value = '';
				}
				var value = questionDetails.Answer.Value;
				if (typeof value === 'undefined') {
					value = '';
				}
				var oldValue = _.get(questionDetails,'Answer.oldValue');
				if(_.isUndefined(oldValue)){
					oldValue = '';
				}


				if (isPercentQuestionTemplate(questionDetails) && typeof value === 'string') {
					//if value contains a '%' and it is not the last character of value remove all characters past the first '%'
					if(_.includes(value,'%') && (value.indexOf('%') !== value.charAt(_.last(value))) ){
					   value = value.substring(0,value.indexOf('%')+1);	
					}
					// removing the '%' at the end of the value
					if (value.charAt(value.length-1) == "%") {
						value = value.substring(0, value.length-1);
					}
					// if the value of the input was blanked out we need to set the Value of the answer on the model to '' as well.
					if(value == ''){
						questionDetails.Answer.Value = '';
					}
				}
				

				// before we continue to process the answer to the question we need to make sure the answer is valid for this question
				if(value != '' && !$s.validateTemplate(questionDetails,value)){
					value = '';
					restoreAnswer(questionDetails,oldValue);
					return false;
				}

			

                //TODO Remove after refactor
				var concepLactactionIds = [129,130,131];
				var concepServiceIds = [132,133,134];
				
				var detailValidation = detailQuetionControl.industryGuideline;
				if (value !== '') {
					$('#'+questionDetails.QuestionId).removeClass('error');
					$('#field'+questionDetails.QuestionId).removeClass('error');
					$('#errorInput'+questionDetails.QuestionId).hide();


					// if the question for number of cows in the pen changes , we need to display a warning dialog letting the user know they have to reassing the body and lameness scores
					if (auditService.checkQuestionNumberCowsInPen(questionDetails) && (averageQuesitonBcsValue.length > 0 || averageQuesitonLsValue.length > 0)) {
						var referentKey = questionDetails.Section + '_' + questionDetails.SubHeading;
						var oldValue = $s.cowsInPenQuestions[referentKey].Answer.oldValue;
						if (typeof oldValue != 'undefined' && oldValue !== '' && value != oldValue) {
							var changeModal = document.getElementById("changeModal");
							changeModal.style.display = "block";
							$(changeModal).attr('data-ref', referentKey);
							return false;
						}
						
					}

					

					
					
					if (isPercentQuestionTemplate(questionDetails)) {
						value = Math.round(value);
						var tmp = [];
						tmp.push(value + '%');
						$("input[id="+ questionDetails.QuestionId +"]").val(tmp);
					}else{
						value = Number(value);
					}
					
					var metGuidelines = true;
					
				    if (detailValidation && detailValidation.compare) {
						metGuidelines = $s.validateCompare(detailValidation.compare, value, questionDetails);
					}
                   //---------------------------------------------------------------------------------------------------------------------------------------------
					//TODO: This section on updating metguidelines of other questions needs to be refactored properly. This is permitted tech debt in the intrest of time, but in no way meets our standards. 
					// we'll need to add some logic/data to the compare property of the questions for this logic.
				
                     // Lactation conception rate 
					if(_.includes(concepLactactionIds,questionDetails.QuestionId)){
						
						if(_.isEqual(questionDetails.QuestionId,129)){
						
								var lactationRate2Answer = _.get(_.find($s.auditAnswers,{QuestionId: 130}),'AnswerDetailsJson.Value');
								var lactationRate3Answer = _.get(_.find($s.auditAnswers,{QuestionId: 131}),'AnswerDetailsJson.Value');
								// if either lactaction rates 2 or 3 are not answered yet then laction 1 hasn't met guidelines
								if((_.isUndefined(lactationRate2Answer) || _.isEqual(lactationRate2Answer,"") || _.isNull(lactationRate2Answer)) || (_.isUndefined(lactationRate3Answer) || _.isEqual(lactationRate3Answer,"") || _.isNull(lactationRate3Answer))){
									metGuidelines  = false;
								}else{
									// if 1st lactation rate's value isn't greater than both laction 2 and 3, then laction 1 hasn't met guidelines 
									if(!_.gt(value,lactationRate2Answer) || !_.gt(value,lactationRate3Answer)){
										metGuidelines = false;
									}
								}
						
						}else{
							var lactationRate1AnswerObject =_.find($s.auditAnswers,{QuestionId: 129});
							var lactationRate1Answer =  _.get(lactationRate1AnswerObject,'AnswerDetailsJson.Value');
                              // we only want to validate lactation rate 1 if it has an actual valid value.   
							if(!_.isUndefined(lactationRate1Answer) && !_.isEqual(lactationRate1Answer,"") && !_.isNull(lactationRate1Answer)){
								
						
									if(_.isEqual(questionDetails.QuestionId,130)){
										var lactationRate3Answer = _.get(_.find($s.auditAnswers,{QuestionId: 131}),'AnswerDetailsJson.Value');
										if(_.isUndefined(lactationRate3Answer) || _.isEqual(lactationRate3Answer,"") || _.isNull(lactationRate3Answer)){
											//if the laction rate 3's answer is not a valid value , lactation rate 1 fails guidelines
											_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
											var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(lactationRate1Question)){
											   _.set(lactationRate1Question,'Answer.MetGuideline',false);
											}
										}else{
											
										    if(!_.gt(lactationRate1Answer,value) || !_.gt(lactationRate1Answer,lactationRate3Answer)){

												_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
												var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
												if(!_.isUndefined(lactationRate1Question)){
													_.set(lactationRate1Question,'Answer.MetGuideline',false);
												}	
											}else{
												var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
												
												if(!_.isUndefined(lactationRate1Question)){
												   var lactRate1MetGuidelines = $s.validateCompare(_.get(lactationRate1Question,'QuestionDetailsJson.industryGuideline.compare',{}), lactationRate1Answer, lactationRate1Question);
                                                   
											    	_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',lactRate1MetGuidelines);
												
												
											       _.set(lactationRate1Question,'Answer.MetGuideline',lactRate1MetGuidelines);
												}
											}

										}

									}else{
										var lactationRate2Answer = _.get(_.find($s.auditAnswers,{QuestionId: 130}),'AnswerDetailsJson.Value');
										if(_.isUndefined(lactationRate2Answer) || _.isEqual(lactationRate2Answer,"") || _.isNull(lactationRate2Answer)){
												//if the laction rate 2's answer is not a valid value , lactation rate 1 fails guidelines
											_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
											var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(lactationRate1Question)){
											   _.set(lactationRate1Question,'Answer.MetGuideline',false);
											}
										}else{
											if(!_.gt(lactationRate1Answer,value) || !_.gt(lactationRate1Answer,lactationRate2Answer)){
												_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
												var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
												if(!_.isUndefined(lactationRate1Question)){
												_.set(lactationRate1Question,'Answer.MetGuideline',false);
												
												}
										   }else{
											var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(lactationRate1Question)){
											
												var lactRate1MetGuidelines = $s.validateCompare(_.get(lactationRate1Question,'QuestionDetailsJson.industryGuideline.compare',{}), lactationRate1Answer, lactationRate1Question);
											
												_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',lactRate1MetGuidelines);
												
												
										    	_.set(lactationRate1Question,'Answer.MetGuideline',lactRate1MetGuidelines);
												

										 	}
										   }
										}
									}
														
							}
						}
					}


                     // service conception rate
					if(_.includes(concepServiceIds,questionDetails.QuestionId)){
						
						if(_.isEqual(questionDetails.QuestionId,132)){
						
								var serviceRate2Answer = _.get(_.find($s.auditAnswers,{QuestionId: 133}),'AnswerDetailsJson.Value');
								var serviceRate3Answer = _.get(_.find($s.auditAnswers,{QuestionId: 134}),'AnswerDetailsJson.Value');
								// if either service rates 2 or 3 are not answered yet then service 1 hasn't met guidelines
								if((_.isUndefined(serviceRate2Answer) || _.isEqual(serviceRate2Answer,"") || _.isNull(serviceRate2Answer)) || (_.isUndefined(serviceRate3Answer) || _.isEqual(serviceRate3Answer,"") || _.isNull(serviceRate3Answer))){
									metGuidelines  = false;
								}else{
									// if service 1 rate's value isn't greater than both service 2 and 3, then service 1 hasn't met guidelines 
									if(!_.gt(value,serviceRate2Answer) || !_.gt(value,serviceRate3Answer)){
										metGuidelines = false;
									}
								}
						
						}else{
							var serviceRate1AnswerObject =_.find($s.auditAnswers,{QuestionId: 132});
							var serviceRate1Answer =  _.get(serviceRate1AnswerObject,'AnswerDetailsJson.Value');
                              // we only want to validate service rate 1 if it has an actual valid value.   
							if(!_.isUndefined(serviceRate1Answer) && !_.isEqual(serviceRate1Answer,"") && !_.isNull(serviceRate1Answer)){
								
						
									if(_.isEqual(questionDetails.QuestionId,133)){
										var serviceRate3Answer = _.get(_.find($s.auditAnswers,{QuestionId: 134}),'AnswerDetailsJson.Value');
										if(_.isUndefined(serviceRate3Answer) || _.isEqual(serviceRate3Answer,"") || _.isNull(serviceRate3Answer)){
											//if the service rate 3's answer is not a valid value , service rate 1 fails guidelines
											_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
											var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(serviceRate1Question)){
											   _.set(serviceRate1Question,'Answer.MetGuideline',false);
											}
										}else{
											
										    if(!_.gt(serviceRate1Answer,value) || !_.gt(serviceRate1Answer,serviceRate3Answer)){

												_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
												var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
												if(!_.isUndefined(serviceRate1Question)){
													_.set(serviceRate1Question,'Answer.MetGuideline',false);
												}	
											}else{
												var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
												
												if(!_.isUndefined(serviceRate1Question)){
												   var serviceRate1MetGuidelines = $s.validateCompare(_.get(serviceRate1Question,'QuestionDetailsJson.industryGuideline.compare',{}), serviceRate1Answer, serviceRate1Question);
                                                   
											    	_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',serviceRate1MetGuidelines);
												
												
											       _.set(serviceRate1Question,'Answer.MetGuideline',serviceRate1MetGuidelines);
												}
											}

										}

									}else{
										var serviceRate2Answer = _.get(_.find($s.auditAnswers,{QuestionId: 133}),'AnswerDetailsJson.Value');
										if(_.isUndefined(serviceRate2Answer) || _.isEqual(serviceRate2Answer,"") || _.isNull(serviceRate2Answer)){
												//if the service rate 2's answer is not a valid value , service rate 1 fails guidelines
											_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
											var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(serviceRate1Question)){
											   _.set(serviceRate1Question,'Answer.MetGuideline',false);
											}
										}else{
											if(!_.gt(serviceRate1Answer,value) || !_.gt(serviceRate1Answer,serviceRate2Answer)){
												_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
												var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
												if(!_.isUndefined(serviceRate1Question)){
												_.set(serviceRate1Question,'Answer.MetGuideline',false);
												
												}
										   }else{
											var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
											if(!_.isUndefined(serviceRate1Question)){
											
												var serviceRate1MetGuidelines = $s.validateCompare(_.get(serviceRate1Question,'QuestionDetailsJson.industryGuideline.compare',{}), serviceRate1Answer, serviceRate1Question);
											
												_.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',serviceRate1MetGuidelines);
												
												
										    	_.set(serviceRate1Question,'Answer.MetGuideline',serviceRate1MetGuidelines);
												

										 	}
										   }
										}
									}
														
							}
						}
					}
                  //---------------------------------------------------------------------------------------------------------------------------------------------

					_.set(questionDetails,"Answer.MetGuideline",metGuidelines);
					_.set(questionDetails,"Answer.Answered",true);
				

				} else {

					if(_.includes(concepLactactionIds,questionDetails.QuestionId) && !_.isEqual(questionDetails.QuestionId,129)){

				     		var lactationRate1AnswerObject =_.find($s.auditAnswers,{QuestionId: 129});
							var lactationRate1Answer =  _.get(lactationRate1AnswerObject,'AnswerDetailsJson.Value');

							// if we have blanked out the answer of either of the other two lactation rate questions , lactation rate 1 fails guidelines
							_.set(lactationRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
							var lactationRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(lactationRate1AnswerObject,'QuestionId')});
							if(!_.isUndefined(lactationRate1Question)){
							   _.set(lactationRate1Question,'Answer.MetGuideline',false);
							}

					}

					if(_.includes(concepServiceIds,questionDetails.QuestionId) && !_.isEqual(questionDetails.QuestionId,132)){

						var serviceRate1AnswerObject =_.find($s.auditAnswers,{QuestionId: 132});
					   var serviceRate1Answer =  _.get(serviceRate1AnswerObject,'AnswerDetailsJson.Value');

					   // if we have blanked out the answer of either of the other two service rate questions , service rate 1 fails guidelines
					   _.set(serviceRate1AnswerObject,'AnswerDetailsJson.MetGuideline',false);
					   var serviceRate1Question = _.find($s.sectionQuestions,{QuestionId: _.get(serviceRate1AnswerObject,'QuestionId')});
					   if(!_.isUndefined(serviceRate1Question)){
						  _.set(serviceRate1Question,'Answer.MetGuideline',false);
					   }

			       }

					// if the quesiton's answer is blanked out we need to reset some other properties of the question answer object. 
					_.set(questionDetails,"Answer.MetGuideline",metGuidelines);



					_.set(questionDetails,"Answer.Answered",false);
                    // if the question was a number of cows in pen question that was blanked out, we need to clear the dependent question answers (avg scores)
					if (auditService.checkQuestionNumberCowsInPen(questionDetails)){
						clearDependentQuestionAndAnswersData(questionDetails.QuestionId,oldValue);
					}

					$('#'+questionDetails.QuestionId).addClass('error');
					$('#field'+questionDetails.QuestionId).addClass('error');
					$('#errorInput'+questionDetails.QuestionId).show();
				}
                // if the question has a calcTag , then we need to update the a question's value that this question is used in a calculaton for. 
				var calcTags = _.get(detailQuetionControl,'calcTag',null);
				if(!_.isNull(calcTags)){
                    questionWithCalculationTagChanged(questionDetails,calcTags);
				} 


				autoSave(questionDetails, value, note);	
				countAnsweredQuestions(questionDetails.SubHeading);
				
			};
				  
			$s.chooseBooleanAnswer = function(questionDetails,answerValue){
			
				log.info("begining booleon function ");
				var value = '';
			    if(_.isEqual(answerValue,'F')){ 
					value = 'T';
				}else{ 
					value = 'F';
				}

				// if this boolean questions has a hide question reason, hide all of the questions with that reason
				var hideQuestionReason = _.get(questionDetails,'HideQuestionReason');

				if(!_.isUndefined(hideQuestionReason)){
					$s.hideShowQuestionsByReason(questionDetails,hideQuestionReason);
				}


				var note = questionDetails.Answer.Notes;
				if (typeof note === 'undefined') {
					note = '';
				}
				questionDetails.showNote = note.length > 0;
				
				var detailValidation = _.get(questionDetails,"QuestionDetailsJson.industryGuideline");
				var metGuidelines = true;
				
                if (detailValidation && detailValidation.compare) {
					metGuidelines = $s.validateCompare(detailValidation.compare, value, questionDetails);
				}
				_.set(questionDetails,"Answer.MetGuideline",metGuidelines);

				if (value.length > 0) {
					_.set(questionDetails,"Answer.Value",value);
					$('#errorSingle'+ questionDetails.QuestionId).hide();
					$('#group-radio'+ questionDetails.QuestionId).removeClass('has-error');
				}
				

				autoSave(questionDetails,value,note);

			}; 
			$s.choseAnswer = function choseAnswer(questionDetails, answerCode) {
				
				log.info("begining chose answer function ");
				var note = questionDetails.Answer.Notes;
				if (typeof note === 'undefined') {
					note = '';
				}
				questionDetails.showNote = note.length > 0;

				if (typeof answerCode === 'undefined') {
					answerCode = '';
				}
				var value = answerCode;
                
				var detailValidation = _.get(questionDetails,"QuestionDetailsJson.industryGuideline");
				var metGuidelines = true;
			
                if(_.isEqual(_.get(questionDetails,'QuestionTemplate',''),"MULTI")){
				 var currentValues = stringListOfValuesToArray(_.get(questionDetails,'Answer.Value',''));
				 //TODO add multi select validation
				
				 value = buildMultiSelectStringValue(_.get(questionDetails,'Answer.Value',''),value);
				}
				
					if (detailValidation && detailValidation.compare) {
						metGuidelines = $s.validateCompare(detailValidation.compare, value, questionDetails);
					}
						
				

				
                _.set(questionDetails,"Answer.MetGuideline",metGuidelines);
				_.set(questionDetails,"Answer.Answered",true);

				if (value.length > 0 && !_.isEqual(_.get(questionDetails,'QuestionTemplate',''),"MULTI")) {
					_.set(questionDetails,"Answer.Value",value);
					$('#errorSingle'+ questionDetails.QuestionId).hide();
					$('#group-radio'+ questionDetails.QuestionId).removeClass('has-error');
				}else{
					_.set(questionDetails,"Answer.Value",value);
				}
				autoSave(questionDetails,value,note);
			};
			//function that takes in a mySync multi select string list of values and converts it to an array
            function stringListOfValuesToArray(valueListString){
			   var valueArray = [];
			   if(!_.isEqual(valueListString,'') && !_.isNull(valueListString) ){
				  
				valueListString = valueListString.replace(/["()']/g,"");
															
			    	valueArray = valueListString.split(',');

			   }
			   
                
			   return valueArray;
				
			}
			//function that takes an array of string values and makes a mySynch string list of values
			function arrayToStringListOfValues(valuesArray){
				var valueListString = "";
						
				if(_.isArray(valuesArray) && valuesArray.length > 0){
					
					valueListString += "(";
					_.forEach(valuesArray,function(value,index, array){

					if(_.isEqual(index,valuesArray.length - 1)){

						valueListString += "'"+value+"'";

					}else{
						valueListString += "'"+value+"',";
					}
					});

					valueListString += ")";

				}
					

				return valueListString;
			}
			//function that takes in the saved value and the new value of a mySynch multi select value and builds the new mySynch multi select value
			function buildMultiSelectStringValue(savedValues,newValue){
			  
				var multiSelectvalue = "";
					
				var valuesArray = stringListOfValuesToArray(savedValues);
				
				if(!_.includes(valuesArray,newValue)){
                   valuesArray.push(newValue);
				}else{
					valuesArray = _.reject(valuesArray,function(value){ return _.isEqual(value,newValue);});
				}
				 
				multiSelectvalue = arrayToStringListOfValues(valuesArray);
				
                return multiSelectvalue;
			}

			$s.onQuestionChange = function onQuestionChange(question){
                if(auditService.checkQuestionNumberCowsInPen(question)){
					$s.cowsInPenQuestionChanging = true;
				} 
			};

			$s.checkRelyOnQuestion = function checkRelyOnQuestion(question){
				var disabled = false;

				var answerValue = _.get(question,'Answer.Value');
				
				if(!_.isNull(question) && ((_.isUndefined(answerValue) || answerValue.length == 0) || (answerValue.length > 0 && $s.cowsInPenQuestionChanging)) ){
					disabled = true;
				}

				return disabled;
			};

			function startAnswerSaveSpinner(question){
				$('#spin'+question.QuestionId).css("display","inline"); // .show();
			}
			function stopAnswerSaveSpinner(question){
				setTimeout(() => {
					$('#spin'+_.get(question,"QuestionId","")).css("display","none"); 
					if(auditService.checkQuestionNumberCowsInPen(question)){
						
						$s.cowsInPenQuestionChanging = false;
						$s.$apply();
					}
				}, 2000);
			}
			function stopAnswerSaveSpinners(questions){
				
				_.forEach(questions,function(question,index,array){
					console.log("setting spinner timeout for quesiton with an id of : "+_.get(question,"QuestionId",""));
					setTimeout(() => {
						
						$('#spin'+_.get(question,"QuestionId","")).css("display","none"); 
						if(auditService.checkQuestionNumberCowsInPen(question)){
							
							$s.cowsInPenQuestionChanging = false;
							$s.$apply();
						}
						array.splice(index,1);
					}, 2000);

                   

				});
		    }
			
			// function that saves or removes an answer from the current audit's answer list 
			function autoSave(questionDetails, value, note) {
			
				log.info("begining autosave function");
			   removeAnswer(questionDetails.QuestionId);
               if(!_.isEqual(value,'')){

			   
				var obAnswer = angular.copy($s.defaultAnswer); 
				_.set(obAnswer,'QuestionId',questionDetails.QuestionId);
				_.set(obAnswer,'AnswerDetailsJson.Answered',true);
				_.set(obAnswer,'AnswerDetailsJson.Value',value);
				_.set(obAnswer,'AnswerDetailsJson.MetGuideline',_.get(questionDetails,"Answer.MetGuideline",true));
				_.set(obAnswer,'AnswerDetailsJson.NoGuideInvolved',true);
				_.set(obAnswer,'AnswerDetailsJson.Notes',note);
				
		 
		
				$s.auditAnswers.push(obAnswer);
			}else{
				//if the value is blank  then we are blanking out an answer to question and need to mark this section review complete false
				//regardless if this was a completed section or not , remove a single question's answer means  the section is incomplete.
				    $s.allowReviewComplete = false; 
				//	localStorage.setItem($s.auditId + "_complete_"+ $s.sectionName, "false");
			}	
			    
				startAnswerSaveSpinner(questionDetails);
				
				
				// save data
				var AnswerDetailsJson = JSON.stringify($s.auditAnswers);
				if(!_.isUndefined(questionDetails)){	
					questionDetails.Answer.oldValue = questionDetails.Answer.Value;
				}
				updateAnswer(auditId, AnswerDetailsJson,false,questionDetails);
				countAnsweredQuestions(questionDetails.SubHeading);
			
			}
			// updateAll = false , question = undefined   where you'd check both to do more logic
			// spinner would be stoped in updateAnswer with 2 sec timeout - update single just the one question - update all process array of quesitons
			function updateAnswer(auditId, AnswerJson,updateAll = false, question = undefined) {
			   if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;	
					$s.checkF360SyncStatus().then(function(){
					
						$s.updateInProgress = true;
						log.info("begining update answer function ");
						

						$s.isDirty = true;
						auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error getting F360 online check: ' + err);
								$s.isDirty = false;
								$s.updateInProgress = false;
								$s.syncInProgress = false;
								
								// if we are not updating a set of question answers, we just stop the single spinner
								if(!updateAll && !_.isUndefined(question)){
									console.log("saving single question with an id of "+_.get(question,'QuestionId',""));
									stopAnswerSaveSpinner(question);
								}
								// if we are updating a set of question answers, we stop each spinner of the queued questions
								if(updateAll){
                                    stopAnswerSaveSpinners($s.saveQuestionAnswerQueue);
								} 
								
								if($s.finalSaveRequired === true){
									log.info("one more save is required 1741");
									$s.finalSaveRequired = false;
									updateAnswer(auditId,JSON.stringify($s.auditAnswers),true);
								}
							}else{
							///	log.info("updateAnswer: updated an answer ");
								// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
								if($s.isOnline){
						
									$s.isDirty = false;
									auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
										if (err) {
											log.error('error updateing isDirty flag: ' + err);
										}
									//	log.info("updateAnswer: updated is dirty flag ");
										auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
										var auditlistItem = _.find(data,{AuditId: auditId});

									//	log.info("using getListByHerdId to get latest sync date");
									//	log.info(auditlistItem);

										//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
										if(!_.isUndefined(auditlistItem)){ 
											auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
												}
												
												
												log.info("updateAnswer: udpated audit sync date after answer update, update answer end");
												$s.updateInProgress = false;
												$s.syncInProgress = false;
												// if we are not updating a set of question answers, we just stop the single spinner
												if(!updateAll && !_.isUndefined(question)){
													console.log("saving single question with an id of "+_.get(question,'QuestionId',""));
													stopAnswerSaveSpinner(question);
												}
												// if we are updating a set of question answers, we stop each spinner of the queued questions
												if(updateAll){
													stopAnswerSaveSpinners($s.saveQuestionAnswerQueue);
												} 
												if($s.finalSaveRequired === true){
													log.info("one more save is required 1787");
													$s.finalSaveRequired = false;
													updateAnswer(auditId,JSON.stringify($s.auditAnswers),true);
												}	
											});	 
										}else{
											log.info("updateAnswer: could not find audit in indexedDB failed to update last sync date, update answer end");
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											// if we are not updating a set of question answers, we just stop the single spinner
											if(!updateAll && !_.isUndefined(question)){
												console.log("saving single question with an id of "+_.get(question,'QuestionId',""));
												stopAnswerSaveSpinner(question);
											}
											// if we are updating a set of question answers, we stop each spinner of the queued questions
											if(updateAll){
												stopAnswerSaveSpinners($s.saveQuestionAnswerQueue);
											} 
											if($s.finalSaveRequired === true){
												log.info("one more save is required 1796");
												$s.finalSaveRequired = false;
												updateAnswer(auditId,JSON.stringify($s.auditAnswers),true);
											}
										}

									});
								});
								}else{
									auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
										if (err) {
											log.error('error updateing isDirty flag: ' + err);
										}
										log.info("updateAnswer: offline but updated dirty flag, update answer end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										// if we are not updating a set of question answers, we just stop the single spinner
										if(!updateAll && !_.isUndefined(question)){
											console.log("saving single question with an id of "+_.get(question,'QuestionId',""));
											stopAnswerSaveSpinner(question);
										}
										// if we are updating a set of question answers, we stop each spinner of the queued questions
										if(updateAll){
											stopAnswerSaveSpinners($s.saveQuestionAnswerQueue);
										} 
										if($s.finalSaveRequired === true){
											log.info("one more save is required 1812");
											$s.finalSaveRequired = false;
											updateAnswer(auditId,JSON.stringify($s.auditAnswers),true);
										}
									});
								}
									
								
										
							}

						
							console.log('update ok');
						});
					});
				}else{
				   log.info("an answer save attempt was made while another one was going");
				   $s.finalSaveRequired = true;
				   if(updateAll){
					   stopAnswerSaveSpinners($s.saveQuestionAnswerQueue);
				   }else{
					   if(!_.isUndefined(question)){
						   if(!_.isUndefined(question) && !_.isNull(question) && !_.includes($s.saveQuestionAnswerQueue,question))
						   $s.saveQuestionAnswerQueue.push(question);
					   }
				   }
				   
				}
			}
			$s.validationSingle = function(questionId) {
				var radios = document.getElementsByName("selector"+questionId);
				var isValid = false;
				var i = 0;
				while (i < radios.length) {
					if (radios[i].checked) {
						isValid = true;
					}
					i++;
				}
				if (!isValid) {
					$('#errorSingle'+questionId).show();
					$('#group-radio'+questionId).addClass('has-error');
				}
				else {
					$('#errorSingle'+questionId).hide();
					$('#'+questionId).removeClass('has-error');
				}
				return isValid;
			};
			$s.validateTemplate = function validateTemplate(question, value) {
				var validationResult = true;

				var valTplType = _.get(question,'QuestionTemplate');
				var validationTemplates = [];
				if(!_.isUndefined(valTplType)){
					var valTplObj = _.find($s.codeFile,{code: valTplType});
					 // if the validation template from code file cannot be found we assume true so that the user
					 // is not prevented from completing the audit     
					if(_.isUndefined(valTplObj)){
						return true;
					}else{
					    if(_.has(valTplObj,'detailsJson') && !_.isNull(valTplObj.detailsJson)){
						   var detailsJson = "";
						   try{ detailsJson = JSON.parse(valTplObj.detailsJson);}catch(e) {log.info("Failed to parse detailsJson of a F360 question template")};
							// currently there is only one version of the details settings, but if there was a need to choose a specific verison,
							// we'd need to refactor the zero index reference.
						   validationTemplates = _.get(detailsJson[0],'settings[0].validationTemplates',[]);
						} 
					}
				}

				
				_.forEach(validationTemplates,function(valTpl){
			
								
				
				    if (validationResult && _.has(valTpl,'MINVALUE')) {	
						validationResult = value >= valTpl.MINVALUE;
					}

					
					if (validationResult && _.has(valTpl,'MAXVALUE')){	
						validationResult = value <= valTpl.MAXVALUE;
					}
						
					
					if (validationResult && _.has(valTpl,'WITHINRANGE')) {
						validationResult = value >= valTpl.WITHINRANGE.loValue && value <= valTpl.WITHINRANGE.hiValue;
					}

				
					if (validationResult && _.has(valTpl,'NOTWITHINRANGE')) {
						validationResult = value < valTpl.WITHINRANGE.loValue || value > valTpl.WITHINRANGE.hiValue;
					}
					
				
					if (validationResult && _.has(valTpl,'WITHINLIST')) {
						validationResult = value in valTpl.WITHINLIST;
					}
					
				
					if ( validationResult && _.has(valTpl,'NOTWITHINLIST')) {
						validationResult = !(value in valTpl.NOTWITHINLIST);
					}
					
					
					
				});
				
					
				
				if (validationResult === true) {
				//	hideWarning(questionDetails.QuestionId);
				} else {
				//	showWarning(questionDetails.QuestionId);
				}
				return validationResult;
			}
			
			$s.validateCompare = function validateCompare(valCop, value, questionDetails) {
				var validationResult = true;
				if (valCop !== undefined) {
					var detailCompare = valCop;
					var number1 = detailCompare.numValue1;
					var number2 = detailCompare.numValue2;
					var strValue = detailCompare.strValue;

					var compareValue1;
					
				    //if strValue exists in detail compare than the question's validation is based on matching strings and the compareValue1 needs to be strValue .
					//Otherwise, compareValue1 needs to be number1 
					if( _.isEqual(strValue,'') || _.isNull(strValue) || _.isUndefined(strValue)){
                       compareValue1 = number1
					}else{
					   compareValue1 = strValue;
					}

					var compareValue2 = number2;


					if (detailCompare.operation) {
						switch (detailCompare.operation) {
							case "NE":
								validationResult = value !== compareValue1;
								break;
							case "GT":
								validationResult = value > compareValue1;
								break;
							case "GE":
								validationResult = value >= compareValue1;
								break;
							case "LE":
								validationResult = value <= compareValue1;
								break;
							case "LT":
								validationResult = value < compareValue1;
								break;
							case "EQ":
								validationResult = value === compareValue1;
								break;
							case "BE":
								validationResult = (value >= compareValue1 && value <= compareValue2);
								break;
							case "IN":
									// first we need to grab the compare value string and remove () and ""
									var valueList = compareValue1;
									valueList = valueList.replace(/["()']/g,""); 
									//then we create an array to compare value to 							
									var values = valueList.split(',');
					
								
									validationResult = (_.includes(values,value));
									

									break;
							case "NI":
								// first we need to grab the compare value string and remove () and ""
								var valueList = compareValue1;
								valueList = valueList.replace(/["()']/g,"");
								//then we create an array to compare value to 							
								var values = valueList.split(',');
								validationResult = (!_.includes(values,value));
								break;
							case "S1":
							    //for S1 type of questions, we just need to make sure at least one answer was chosen
							    var selectedValueList = value.replace(/["()']/g,"");
							
								selectedValueList = selectedValueList.split(',');
								validationResult = selectedValueList.length >= 1 && !_.isEqual(selectedValueList[0],"");
							   
								break;
							case "X1":
                 	           // first we need to grab the compare value string and remove () and ""
							   var valueList = compareValue1;
						       valueList = valueList.replace(/["()']/g,""); 
							
							   //then we create an array to compare the selected value(s) to 							
					           var values = valueList.split(',');

								if(_.isEqual(_.get(questionDetails,'QuestionTemplate',''),'MULTI')){
								 // if the quesiton is a multi select we have to make an array of the values as well
									var selectedValueList = value.replace(/["()']/g,""); 
									selectedValueList = selectedValueList.split(',');	
									
									//first we need to determin if at least one of the selected answers matches the valid answer choices 
									var selectedValidAnswer = false;
									_.forEach(selectedValueList,function(selectedValue){
									 
										if(_.includes(values,selectedValue)){
											// if one of the selected answers is a valid answer , we set the flag and exit the foreach
											selectedValidAnswer = true;
											return false;
										};
										
									});

									// next we need to determin if there has been more than one answer chosen 
									var onlyOneAnswerChosen = selectedValueList.length == 1 && !_.isEqual(selectedValueList[0],"");

									validationResult = selectedValidAnswer && onlyOneAnswerChosen;

							     }

							    break;
							default:
								break;
						}
					}
				}
				if (validationResult === true) {
				//	hideWarning(questionDetails.QuestionId);
				} else {
				//	showWarning(questionDetails.QuestionId);
				}
				return validationResult;
			}
			function showWarning(id) {
				$('#warning'+id).show();
				$('#texthelp'+id).addClass('mt-5');
			}
			function hideWarning(id) {
				$('#warning'+id).hide();
				$('#texthelp'+id).removeClass('mt-5');
			}
			$s.disableQuestion = function (questionDetails) {

                if($s.initCheckSyncInProgress === true){
					return true;
				}

				if (typeof $s.notApplicableQuestions.Answer !== "undefined" ) {
					var value = $s.notApplicableQuestions.Answer.Value;
					if (value == f360Constant.answerTrue) {
						if (questionDetails.SubHeading == $s.notApplicableQuestions.SubHeading) {
							return true;
						} else {
							// if the question is a calculated question and one of its dependent questions is disabled 
							// this question should aslo be disabled 
							if(!_.isUndefined(_.get(questionDetails,'QuestionDetailsJson.calculations.calculationVars')) && questionDetails.QuestionDetailsJson.calculations.calculationVars.length > 0){
								  var calcVarArray = _.get(questionDetails,'QuestionDetailsJson.calculations.calculationVars');
								  
								  var valueTagObjects = [];

								   _.forEach(calcVarArray,function(calcVarObject){
									   var calcVarObjectKey = _.keys(calcVarObject)[0];
									   valueTagObjects.push(calcVarObject[calcVarObjectKey]);
									  

								   });


								  var isDisabled = false;

								  _.forEach(valueTagObjects,function(valueTagObject){
									   
									   var matchingCalcQuestions = _.filter($s.auditQuestions,function(question){ return _.includes(_.get(question,'QuestionDetailsJson.calcTag',[]),valueTagObject.valueTag[0]) && _.isEqual(question.SubHeading,valueTagObject.subHeading);}); 
									   
									   _.forEach(matchingCalcQuestions,function(calcQuestion){
										   // first we try to see if the question is a text input question
											var input = $("#field"+calcQuestion.QuestionId).parent();
											
											if(input.length > 0){

												var elememntsWithDisabledClass = input.siblings('.mysynch-disabled');

												if(elememntsWithDisabledClass.length > 0){
													isDisabled = true;
													if(!_.includes($s.excludedQuestionIds,questionDetails.QuestionId)){
														$s.excludedQuestionIds.push(questionDetails.QuestionId);
														
													}
													countAnsweredQuestions(questionDetails.SubHeading);
													return false;
												}
												
											}else{
											  //otherwise the question is likely to be a single or multi selection question
											 input = $("#group-radio"+calcQuestion.QuestionId);
											 
											  if(input.length > 0){

												 var elememntsWithDisabledClass = input.find('.div-disabled');

												 // if there are one or more answer choices that are disabled then we disable this question
												 if(elememntsWithDisabledClass.length > 0){
													 isDisabled = true;
													 if(!_.includes($s.excludedQuestionIds,questionDetails.QuestionId)){
														$s.excludedQuestionIds.push(questionDetails.QuestionId);
													}
													countAnsweredQuestions(questionDetails.SubHeading);
													 return false;
												 }

											  }else{
												 // if question element was not found , we'll just leave isDisabled = false and break out of the loop
												 // better to have disableQuesiton return false and still allow the user to fill in the question
												 
												 return false;
											  }

											}
									   });

									   if(isDisabled){
										   return false
									   }


								  });

								  return isDisabled;


							}else{
								return false;
							}
							
						}
					} else {
						// when the TF N/A question is unchecked we want to clear the exluded questions  
						$s.excludedQuestionIds = [];
						countAnsweredQuestions(questionDetails.SubHeading);
						return false;
					}
				}
			};
			$s.reviewComplete = function reviewComplete() {
				if ($s.allowReviewComplete) {
			
				 
				 var sectionItem = _.find($s.overViewList,{Section: _.get(_.first($s.sectionQuestions),'Section')});
				 _.set(sectionItem,'ReviewComplete',true);
				 var OverviewListJson = JSON.stringify($s.overViewList);
				 $s.isDirty = true;
				 auditService.updateAuditSectionsData($s.auditId, OverviewListJson, function getF360UpdateAuditSectionsData(err, data) {
					if (err) {
						log.error('error getting Update Audit Sections Data: ' + err);
						$s.isDirty = false;
						$s.updateInProgress = false;
					}else{
					///	log.info("updateAuditSectionsData: updated an answer ");
						// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
						if($s.isOnline){
                  
							$s.isDirty = false;
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
							//	log.info("updateAuditSectionsData: updated is dirty flag ");
								auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
								var auditlistItem = _.find(data,{AuditId: auditId});

						     //	log.info("using getListByHerdId to get latest sync date");
							//	log.info(auditlistItem);

								 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
								if(!_.isUndefined(auditlistItem)){ 
									auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
										if (err) {
											log.error('error updating device last sync date: ' + err);
										}
										log.info("updateAuditSectionsData: updated audit sync date after updateAuditSectionsData update , update updateAuditSectionsData end");
										$s.updateInProgress = false;	
										$window.location.href = '#/f360/'+$s.auditId+'/evaluation-overview';
										
									});	 
								}else{
									log.info("updateAuditSectionsData: could not find audit in indexedDB failed to update last sync date, update updateAuditSectionsData end");
									$s.updateInProgress = false;
								}

							});
						  });
						}else{
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
								log.info("updateAuditSectionsData: offline but updated dirty flag, update updateAuditSectionsData end");
								$s.updateInProgress = false;
								$window.location.href = '#/f360/'+$s.auditId+'/evaluation-overview';
							});
						}
							
						
					  			 
				    }
						 
					
					});
				//	localStorage.setItem($s.auditId + "_complete_"+ $s.sectionName, "true");
					
				}
			};
			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();


           
			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// $s.debugConsoleText += "onLineValue: "+onLineValue+"<br>"
					// 					   +"isOnlineOldValue: "+isOnlineOldValue+"<br>"
					// 					   +"isOnline: "+$s.isOnline+"<br>";
					
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					// $s.debugConsoleText += "syncingBackOnline: "+$s.syncingBackOnline+"<br>";
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						 // $s.debugConsoleText += "begining checkF360SyncStatus <br>";
						  $s.checkF360SyncStatus().then(function(){
						//	$s.debugConsoleText += "checkF360SyncStatus done <br>";
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
							 
						  });
					  } 
				 }
				 
			 });
			
			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();

				if ($s.isOnline && $s.updateInProgress === false) {


				
					log.info("Section Page : checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){
						
						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}

						var activeAuditListData = _.find(data,{AuditId: $s.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					   //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
					   if(	$s.updateInProgress === true){
						log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
						   syncStatusPromise.reject(true);
						   return;
					   }

					 //  log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   api.getSyncStatus($s.auditId,lastSyncedDate,isDeviceDirty, function getF360SyncStatus(err, data) {
								if (err) {
							
									log.error('error getting F360 online check: ' + err);
								}

								 //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								 if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									return;
								}
								
								if (data) {
								
								
									var syncData = data[0];	

									if(!_.isUndefined(syncData)){
									
									//	log.info("checkedSync: synce data returned with");
									//	log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData($s.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty($s.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: $s.auditId});
	
													//	log.info("checkedSync: updating last synced date with : ");
													//	log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate($s.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
															
																syncStatusPromise.resolve(true);
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
														
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
												
													syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													
													syncStatusPromise.resolve(true);
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										
										syncStatusPromise.resolve(true);
									}

								} else {
								
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
				
					syncStatusPromise.resolve(true);
				}
			  return syncStatusPromise.promise;
			}
		

			$s.$on("$destroy", function() {
		
				$interval.cancel($s.checkSyncStatusTimer);
				deregOnFarmChange();
				degregAuditAnswersWatch();
				deregOnlineCheckWatch();
			
			
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});

								 

			MSF.ready(function onMsfReady() {

				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				try{
					var answerTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ANSWER"}),'detailsJson'));
					var  maxAnswerTemplateApiVer = _.max(
															_.map(answerTemplateDetailsJsonArray,function(answerTmplDetailsVersion){
																var apiVerNumStr = _.get(answerTmplDetailsVersion,'apiVersion').replace("v","");
																return parseFloat(apiVerNumStr);
															})
														);
					$s.defaultAnswer =  _.get(_.find(answerTemplateDetailsJsonArray,{apiVersion:`v${maxAnswerTemplateApiVer}`}),'template');
													

				// set original default values that differ than how its defined in sql , but  might not actually need to be these values
				_.set($s.defaultAnswer,'AnswerDetailsJson.Answered',null);
				_.set($s.defaultAnswer,'AnswerDetailsJson.Value',undefined);
				_.set($s.defaultAnswer,'AnswerDetailsJson.MetGuideline',undefined);
				_.set($s.defaultAnswer,'AnswerDetailsJson.NoGuideInvolved',null);
				_.set($s.defaultAnswer,'AnswerDetailsJson.Notes',undefined);
				_.set($s.defaultAnswer,'AnswerDetailsJson.FormattedRecommends',undefined);
				_.set($s.defaultAnswer,'AnswerDetailsJson.TargetDate',null);


				}catch(e){
				log.info("Section Page: Answer Template failed to be acquired from Code File or failed to be parsed");
				}

				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion().then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });
                // first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
				   	// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
					   // then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
					    loadCurrentHerd(function(){
							$s.loadReportData();
						});				
				      
					});

				}); 
		
			
			});

						
			degregAuditAnswersWatch = $s.$watch('auditAnswers',function(newValues,oldValues,scope){

				   //TODO: remove watch later when the relationship between setting avg body/lameness scores is refactored
				   // we need watch 3 specific body score fields for when their values change for the two abs diff calculations need updating
				if(_.isEqual($s.sectionName,"FARMWALKTHRU")){
						var avgBscAnswers = _.filter(newValues,function(answer){
							return (answer.QuestionId == 5 || answer.QuestionId == 16 || answer.QuestionId == 27);
						});

						var oldAvgBscAnswers = _.filter(oldValues,function(answer){
							return (answer.QuestionId == 5 || answer.QuestionId == 16 || answer.QuestionId == 27);
						});

							var removedAvgBscAnswers = _.difference(oldAvgBscAnswers,avgBscAnswers); 

                        //if any of the 3 watched question's values changed we need to update the questions matching their calc tag if needed.
						_.forEach(avgBscAnswers,function(answer){
							var newValue = _.get(answer,'AnswerDetailsJson.Value');
							var oldValue = _.get(_.find(oldValues,function(oldAnswer){return oldAnswer.QuestionId === answer.QuestionId;}),'AnswerDetailsJson.Value');

							if(!_.isEqual(newValue,oldValue)){
								var avgBscQuestion = _.find($s.auditQuestions,function(question){return question.QuestionId === answer.QuestionId;});
								var avgBscQuestionCalcTags = _.get(avgBscQuestion,'QuestionDetailsJson.calcTag');
								questionWithCalculationTagChanged(avgBscQuestion,avgBscQuestionCalcTags);
							
							}
						});
                        // if any of the 3 watched question's values were blanked out , we still need to possibly update (blank out) the questions matching their calc tag
						_.forEach(removedAvgBscAnswers,function(answer){
								var avgBscQuestion = _.find($s.auditQuestions,function(question){return question.QuestionId === answer.QuestionId;});
								var avgBscQuestionCalcTags = _.get(avgBscQuestion,'QuestionDetailsJson.calcTag');
								questionWithCalculationTagChanged(avgBscQuestion,avgBscQuestionCalcTags);
						
						});
			     }


			});
			
		}
	]);
})();
